import { Component, ChangeDetectorRef, DoCheck, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs';
import { TsInputComponent } from 'tsui';

import { AccountService } from 'app/core';
import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './typeahead-form-field.component.html',
  styleUrls: ['./../form-field.component.scss'],
})
export class TypeaheadFormFieldComponent extends FormFieldComponent implements DoCheck {
  @ViewChild(TsInputComponent) private readonly tsInput?: TsInputComponent;

  public readonly control = new FormControl('');
  public searchResults: any[] | null;
  public value: any;
  private _originalValue: any;

  // Duck-typed contract read by form-field.component.ts to avoid clobbering an in-progress edit.
  get inputControl(): ElementRef<HTMLInputElement> | undefined {
    return this.tsInput?.inputElement();
  }

  constructor(
    private _accountService: AccountService,
    private readonly _cdRef: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;

    this.control.setValue(this.value, { emitEvent: false });
    this.updateDisabledState();

    this.control.valueChanges
      .pipe(
        takeUntilDestroyed(this.dRef),
        tap((value) => (this.value = value)),
        debounceTime(400),
        distinctUntilChanged(),
      )
      .subscribe((value) => {
        this._accountService.typeaheadSearch(value, this.fieldDef.name).subscribe((response) => {
          this.searchResults = response;
          this._cdRef.markForCheck();
        });
      });
  }

  ngDoCheck(): void {
    this.updateDisabledState();
  }

  onAutocompleteClosed(): void {
    this.onSave();
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;
    this.control.setValue(this.value, { emitEvent: false });
  }

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  private updateDisabledState(): void {
    if (this.isDisabled === this.control.disabled) {
      return;
    }

    if (this.isDisabled) {
      this.control.disable({ emitEvent: false });
    } else {
      this.control.enable({ emitEvent: false });
    }
  }
}
